// import { ARCH } from "../../Data/typeDirs"

import { REP_IMG, REP_V2 } from "../../Data/typeDirs"
import { DROPDIR } from "../../Services/filenameUtils"
import { genId } from "../../utils"


const ARCHDIR = 'Archive'

export class ReportImage{
  constructor(data = {}){
    this._id = data._id || genId()
    this.content = data.content
    this.created = data.created || Date.now()
    this._createdBy = data._createdBy 
    this._modifiedBy = data._modifiedBy
    this.modified = data.modified
    this._reports_v2 = data._reports_v2
    this._report_blocks = data._report_blocks
    this.orderIndex = data.orderIndex || 0
    this.thumbnailSize = data.thumbnailSize || 'md'
    this.dbg_id = data.dbg_id
    this.dropboxPath = data.dropboxPath
    this.type = ReportImage.getTypeDir()
    this.storageLocation = data.storageLocation || null
    
  }

  static getIndices() { return '_id' }

  static getTypeDir() { return REP_IMG }

  static getDropboxPath(_id, dirName){
    return `/${DROPDIR}/${REP_V2}/${dirName}/${_id}.jpg`
  }

  static getDropboxArchivePath(_id, dirName){
    return `/${ARCHDIR}/${REP_V2}/${dirName}/${_id}.jpg`
  }

  static getLocalPath(locroot, dirName, _id){
    return `${locroot}/${REP_IMG}/${dirName}/${_id}.jpg`
  }

  async getDropboxPath(dirName, dataSource){
    if(!dirName){
      dirName = await dataSource('remDb')[REP_V2].get({_id:this._reports_v2}).dirName
    }
    return ReportImage.getDropboxPath(this._id)
  }
  async getDropboxArchivePath(dirName, dataSource){
    if(!dirName){
      dirName = await dataSource('remDb')[REP_V2].get({_id:this._reports_v2}).dirName
    }
    return ReportImage.getArchivePath(this._id)
  }
}